import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useCoreController } from '@/services/coreController'
import { analyticsService } from '@/services/analytics'

/**
 * Capture le commercial_id depuis une URL de parrainage (/share/:id ou /:id)
 * avant de rediriger vers la home. Sans ce composant, React Router remplace
 * l'URL immédiatement et le paramètre est perdu.
 */
export function CaptureCommercialIdRedirect() {
  const { commercialId } = useParams<{ commercialId?: string }>()
  const coreController = useCoreController()

  useEffect(() => {
    if (commercialId) {
      coreController.setCommercialId(commercialId)
      analyticsService.setCommercialId(commercialId)
    }
  }, [commercialId, coreController])

  return <Navigate to="/" replace />
}
